import React, { useEffect } from "react";

// slide images
import Slide1 from "../images/slide-1.jpg";
import Slide2 from "../images/slide-2.jpg";
import Slide3 from "../images/slide-3.jpg";


// js
import { HomeHeader } from "../js/main";

// component
import ContactUs from "./ContactUs";
import WhyUs from "./WhyUs";
import Specials from "./Specials";
import Gallery from "./Gallery";
import Chefs from "./Chefs";
import { useSelector } from "react-redux";

const Home = () => {
    useEffect(() => {
        HomeHeader();
    }, []);

    const { isAuth } = useSelector((state) => state.user);

    const sliderData = [
        Slide1,
        Slide2, Slide3
    ]
    return (
        <>
            <section id="hero">
                <div className="hero-container">
                    <div
                        id="heroCarousel"
                        data-interval="5000"
                        className="carousel slide carousel-fade"
                        data-ride="carousel"
                    >
                        <ol className="carousel-indicators" id="hero-carousel-indicators">
                            <li
                                data-target="#heroCarousel"
                                data-slide-to="0"
                                className="active"
                                aria-current="true"
                            ></li>
                            <li data-target="#heroCarousel" data-slide-to="1" className=""></li>
                            <li data-target="#heroCarousel" data-slide-to="2" className=""></li>
                        </ol>

                        <div className="carousel-inner">
                            {
                                sliderData?.map((data, index) => {
                                    return (
                                        <div
                                            className={`carousel-item ${index === 1 && "active"}`}
                                            style={{ backgroundImage: `url(${data})` }}
                                        >
                                            <div className="carousel-container">
                                                <div className="carousel-content">
                                                    <h2 className="animate__animated animate__fadeInDown">
                                                        WelCome To <span>Delicious</span> Restaurant
                                                    </h2>
                                                    <p className="animate__animated animate__fadeInUp h5">
                                                        {!isAuth ?
                                                            "Please register to set your preferences." : "Rain or Shine it's time to Dine."
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>

                        <a
                            className="carousel-control-prev"
                            href="#heroCarousel"
                            role="button"
                            data-slide="prev"
                        >
                            <span className="carousel-control-prev-icon" aria-hidden="true">
                                <i className="fas fa-chevron-left"></i>
                            </span>
                        </a>

                        <a
                            className="carousel-control-next"
                            href="#heroCarousel"
                            role="button"
                            data-slide="next"
                        >
                            <span className="carousel-control-next-icon" aria-hidden="true">
                                <i className="fas fa-chevron-right"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </section>
            <main id="main">
                <WhyUs />
                <Gallery />
                {
                    isAuth &&
                    <Specials />
                }
                <Chefs />
                <ContactUs />
            </main>

        </>
    );
};

export default Home;
